import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { useAuctionLivePageParams } from 'src/pages/transport/network-points/details/point-details/auction-live-table';

const favouriteNetworkPointsSchema = getPaginationSchema({ pageSize: 5 });

export function useDashboardPageParams() {
  const favouriteNetworkPoints = usePageParamsFromSchema(
    favouriteNetworkPointsSchema,
    { groupPrefix: 'favouriteNetworkPoints' }
  );

  const auctionLive = useAuctionLivePageParams();

  return {
    favouriteNetworkPoints,
    auctionLive,
  };
}

export type DashboardPageParams = ReturnType<typeof useDashboardPageParams>;
